const AccessDenied = () => {
  return (
    <div data-testid="access-denied" className="text-center mt-[20%]">
      <p className="text-9xl font-normal">Access Denied!!</p>
      <p className="text-2xl font-normal">You don't have access to this page</p>
    </div>
  );
};
export default AccessDenied;
